module.exports = __webpack_public_path__ + "static/media/close_icon.90ff1d25.svg";